/**
 * Generated by orval v8.0.0-rc.2 🍺
 * Do not edit manually.
 * SEMO API
 * ## SEMO MVP REST API

한국 서비스 마켓플레이스 백엔드 API 문서. 인증, 채팅, 견적, 계약, 결제를 포함합니다.

**버전**: `v0.1.0`
 * OpenAPI spec version: 0.1.0
 */
import * as zod from "zod";

/**
 * 견적서 PDF를 생성합니다.
 * @summary Quote PDF 생성
 */

export const pdfControllerGenerateQuotePdfBodyItemsItemUnitPriceMin = 0;

export const pdfControllerGenerateQuotePdfBodyItemsItemTotalPriceMin = 0;

export const pdfControllerGenerateQuotePdfBodySubtotalMin = 0;

export const pdfControllerGenerateQuotePdfBodyTaxMin = 0;

export const pdfControllerGenerateQuotePdfBodyTotalAmountMin = 0;

export const pdfControllerGenerateQuotePdfBody = zod
  .object({
    supplierName: zod.string().describe("공급자 회사명"),
    supplierCeoName: zod.string().describe("공급자 대표자명"),
    supplierRegistrationNumber: zod.string().describe("사업자등록번호"),
    supplierAddress: zod.string().describe("공급자 주소"),
    supplierPhone: zod.string().describe("공급자 전화번호"),
    supplierEmail: zod.string().describe("공급자 이메일"),
    companySealUrl: zod.string().optional().describe("회사 직인 URL (선택)"),
    buyerName: zod.string().describe("구매자명 (또는 회사명)"),
    announcementNumber: zod.string().optional().describe("공고번호 (선택)"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품명 (Product name)"),
            spec: zod.string().optional().describe("규격 (Specification)"),
            quantity: zod.number().min(1).describe("수량 (Quantity)"),
            unit: zod.string().describe("단위 (Unit)"),
            unitPrice: zod
              .number()
              .min(pdfControllerGenerateQuotePdfBodyItemsItemUnitPriceMin)
              .describe("단가 (Unit price)"),
            totalPrice: zod
              .number()
              .min(pdfControllerGenerateQuotePdfBodyItemsItemTotalPriceMin)
              .describe("금액 (Total price)"),
          })
          .strict(),
      )
      .describe("견적 항목 목록"),
    subtotal: zod
      .number()
      .min(pdfControllerGenerateQuotePdfBodySubtotalMin)
      .describe("공급가액 (부가세 제외)"),
    tax: zod
      .number()
      .min(pdfControllerGenerateQuotePdfBodyTaxMin)
      .describe("부가세 (10%)"),
    totalAmount: zod
      .number()
      .min(pdfControllerGenerateQuotePdfBodyTotalAmountMin)
      .describe("총 금액 (공급가액 + 부가세)"),
    categoryType: zod
      .enum(["product", "service"])
      .describe("카테고리 (제품/서비스)"),
    description: zod.string().optional().describe("설명 (선택)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명 (File name)"),
            fileUrl: zod.string().describe("파일 URL (File URL)"),
          })
          .strict(),
      )
      .optional()
      .describe("첨부파일 목록 (선택)"),
  })
  .strict();

/**
 * 계약서 PDF를 생성합니다.
 * @summary Contract PDF 생성
 */

export const pdfControllerGenerateContractPdfBodyItemsItemUnitPriceMin = 0;

export const pdfControllerGenerateContractPdfBodyItemsItemTotalPriceMin = 0;

export const pdfControllerGenerateContractPdfBodySubtotalMin = 0;

export const pdfControllerGenerateContractPdfBodyTaxMin = 0;

export const pdfControllerGenerateContractPdfBodyTotalAmountMin = 0;

export const pdfControllerGenerateContractPdfBody = zod
  .object({
    supplierName: zod.string().describe("공급자 회사명"),
    supplierCeoName: zod.string().describe("공급자 대표자명"),
    supplierRegistrationNumber: zod.string().describe("사업자등록번호"),
    supplierAddress: zod.string().describe("공급자 주소"),
    supplierPhone: zod.string().describe("공급자 전화번호"),
    supplierEmail: zod.string().describe("공급자 이메일"),
    companySealUrl: zod.string().optional().describe("회사 직인 URL (선택)"),
    buyerName: zod.string().describe("구매자명 (또는 회사명)"),
    announcementNumber: zod.string().optional().describe("공고번호 (선택)"),
    items: zod
      .array(
        zod
          .object({
            name: zod.string().describe("품명 (Product name)"),
            spec: zod.string().optional().describe("규격 (Specification)"),
            quantity: zod.number().min(1).describe("수량 (Quantity)"),
            unit: zod.string().describe("단위 (Unit)"),
            unitPrice: zod
              .number()
              .min(pdfControllerGenerateContractPdfBodyItemsItemUnitPriceMin)
              .describe("단가 (Unit price)"),
            totalPrice: zod
              .number()
              .min(pdfControllerGenerateContractPdfBodyItemsItemTotalPriceMin)
              .describe("금액 (Total price)"),
          })
          .strict(),
      )
      .describe("견적 항목 목록"),
    subtotal: zod
      .number()
      .min(pdfControllerGenerateContractPdfBodySubtotalMin)
      .describe("공급가액 (부가세 제외)"),
    tax: zod
      .number()
      .min(pdfControllerGenerateContractPdfBodyTaxMin)
      .describe("부가세 (10%)"),
    totalAmount: zod
      .number()
      .min(pdfControllerGenerateContractPdfBodyTotalAmountMin)
      .describe("총 금액 (공급가액 + 부가세)"),
    categoryType: zod
      .enum(["product", "service"])
      .describe("카테고리 (제품/서비스)"),
    description: zod.string().optional().describe("설명 (선택)"),
    attachments: zod
      .array(
        zod
          .object({
            fileName: zod.string().describe("파일명 (File name)"),
            fileUrl: zod.string().describe("파일 URL (File URL)"),
          })
          .strict(),
      )
      .optional()
      .describe("첨부파일 목록 (선택)"),
    contractNumber: zod.string().describe("계약번호"),
    contractDate: zod.string().describe("계약일자 (ISO8601)"),
    paymentTransactionId: zod.string().describe("결제 트랜잭션 ID"),
    paymentApprovedAt: zod.string().describe("결제 승인일시 (ISO8601)"),
  })
  .strict();
